import type { CourseState } from '../../canvas/CourseState';
import type { JumpingCourse } from '../../canvas/JumpingCourse';

let _courseState: CourseState | null = null;
let _jumpingCourse: JumpingCourse | null = null;
const _stateListeners = new Set<() => void>();

export function setCourseState(state: CourseState): void {
  _courseState = state;
  _stateListeners.forEach(fn => fn());
}

/** Subscribe to CourseState changes (remount). Returns unsubscribe function. */
export function onCourseStateChange(fn: () => void): () => void {
  _stateListeners.add(fn);
  return () => _stateListeners.delete(fn);
}

export function getCourseState(): CourseState | null {
  return _courseState;
}

export function setJumpingCourse(course: JumpingCourse): void {
  _jumpingCourse = course;
}

export function getJumpingCourse(): JumpingCourse | null {
  return _jumpingCourse;
}
